<router-outlet></router-outlet>
<app-vault-console></app-vault-console>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate" [fullScreen]="true">
  <p style="color: white"></p>
</ngx-spinner>